import { Component, Input, inject, input, computed } from '@angular/core';
import { AppService } from '@lc/core';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { NotesDialogService, NotesDialogServiceConfig } from '../dialogs/notes-dialog/notes-dialog.service';

@Component({
  selector: 'lc-notes-bubble',
  templateUrl: './notes-bubble.component.html',
  styleUrls: ['./notes-bubble.component.scss'],
  imports: [MatIcon, MatButton],
})
export class NotesBubbleComponent {
  private notesDialog = inject(NotesDialogService);

  @Input() orderId: string = '';
  @Input() agentId?: string;
  @Input() title: string = 'Notes';
  @Input() subtitle?: string;
  noteCount = input<number>(0);

  readonly isCoordinatorApp: boolean = AppService.isCoordinatorApp;

  displayCount = computed(() => {
    const count = this.noteCount();
    return count > 9 ? '+9' : `+${count}`;
  });

  openNotes() {
    if (!this.notesDialog.isNotesOpen() && this.orderId) {
      const config: NotesDialogServiceConfig = {
        orderId: this.orderId,
        agentId: this.agentId,
        title: this.title,
        subtitle: this.subtitle,
      };
      this.notesDialog.openNotes(config);
    }
  }
}
